import React from 'react';
import classNames from 'classnames';
import ScorecardAnswerBubbles from 'components/pure/scorecards/ScorecardAnswerBubbles';
import './SubmitContentDetailScore.styl';
import ScorecardQuestionReason from 'components/pure/scorecards/ScorecardQuestionReason';
import isNil from 'lodash/isNil';
import RichTextEditor from 'components/pure/utils/form/user-taggable-input/RichTextEditor';
import connectToStores from 'alt-utils/lib/connectToStores';
import ScorecardStore from 'stores/ScorecardStore';
import CardReasonStore from 'stores/CardReasonStore';
import Loading from 'components/pure/utils/Loading';
import {QUESTION_TYPE_TYPE} from 'records/CoachingReviewTypeQuestion';

export const makePrompt = (question, contentDetailScore, skillName, otherUser) =>
  question
    ? question.text
    : contentDetailScore.contentDetail.custom ||
      `How would you rate ${otherUser ? otherUser.firstName : ''} on ${skillName} in this call?`;

@connectToStores
export default class SubmitContentDetailScore extends React.PureComponent {
  static getStores() {
    return [ScorecardStore, CardReasonStore];
  }

  static getPropsFromStores() {
    const {cardReasons} = CardReasonStore.getState();
    const {scorecardQuestions, scorecardsMap} = ScorecardStore.getState();

    return {
      reasonSchemes: cardReasons,
      questionMap: scorecardQuestions,
      scorecardsMap: scorecardsMap,
    };
  }

  getReasonSchemeForQuestion(question, reasonSchemes) {
    const schemeId = question.cardReasonSchemeId;
    if (schemeId && reasonSchemes) {
      return reasonSchemes.find(scheme => scheme.id === schemeId);
    } else {
      return null;
    }
  }

  render() {
    const {
      scorecardId,
      otherUser,
      contentDetailScore,
      onChange,
      disabled,
      isCoach,
      // support "summary" (see CoachingReviewListeningAssistant - we mostly remove some styles, header, etc.)
      summary,
      reasonSchemes,
      questionMap,
      scorecardsMap,
    } = this.props;
    const skillName = contentDetailScore.contentDetail.skillName;

    const question = questionMap.get(contentDetailScore.scorecardQuestionId);
    // favor questions scorecard scheme, otherwise use the plan's scorecard
    const scorecard = scorecardsMap.get(question?.scorecardId ?? scorecardId);
    if (contentDetailScore.scorecardQuestionId && !scorecard) {
      return <Loading />;
    }
    const scoringScheme =
      question && scorecard ? scorecard.scoringScheme : QUESTION_TYPE_TYPE.ContentDetail;

    const prompt = makePrompt(question, contentDetailScore, skillName, otherUser);
    const allowComment = !question || question.allowComments;
    const comment = question || !skillName ? 'Comment:' : `Comment on your ${skillName} score:`;
    const reasonScheme = question ? this.getReasonSchemeForQuestion(question, reasonSchemes) : null;

    // ScorecardQuestionReason expects a string answer
    const answer = isNil(contentDetailScore.score) ? 'n/a' : contentDetailScore.score + '';

    return (
      <div className="submit-content-detail-score">
        <div className={classNames('skill', !isCoach && 'always-disabled', summary && 'narrow')}>
          {!summary && <div className="prompt">{prompt}</div>}
          <div className="response">
            <ScorecardAnswerBubbles
              selectKey="value"
              disabled={disabled}
              scoringScheme={scoringScheme}
              answer={contentDetailScore.score}
              onSelectAnswer={(_, score) =>
                onChange(contentDetailScore.set('score', score).set('reason', null))
              }
              isCoaching
            />
          </div>
        </div>
        {!disabled && reasonScheme && (
          <div className={classNames('reason', summary && 'narrow')}>
            <ScorecardQuestionReason
              reason={contentDetailScore.reason}
              reasonScheme={reasonScheme}
              answer={answer}
              onReasonChange={
                !disabled && ((questionId, val) => onChange(contentDetailScore.set('reason', val)))
              }
              questionId={question.id}
            />
          </div>
        )}
        {allowComment && (
          <div className="comment">
            <div className="prompt">(Optional) {comment}</div>
            <div className="comment-response">
              <RichTextEditor
                value={contentDetailScore.comment || ''}
                onChange={!disabled && (val => onChange(contentDetailScore.set('comment', val)))}
                disabled={disabled}
                abbreviatedOptions={summary}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
